// extracted by mini-css-extract-plugin
export default {"dlReportsList":"src-js-containers-reports-components-ReportsList---dlReportsList---P7Xaq"};